import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LoyaltyEsimDetailsModal from 'loyalty/components/LoyaltyEsimDetailsModal'
import Label from 'LuxKit/Label/Label'
import Group from 'components/utils/Group'
import { ESIM_IMAGE } from 'loyalty/constants/loyaltyEsimConstants'

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyEsimPackage(props: Props) {
  const { tier, benefit, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()

  const gbAmount = benefit.value?.unit === 'GB' ? benefit.value.amount : 0

  const heading = intl.formatMessage(
    {
      id: 'JctgWoypxBZBQ3R2iuUu',
      defaultMessage: '{amount}GB Free Data Roaming',
      description: 'Heading for eSIM benefit tile on account landing page',
    },
    { amount: gbAmount || '-' },
  )

  const handleDetailsClick = useCallback(() => {
    showModal(<LoyaltyEsimDetailsModal />)
  }, [showModal])

  return (
    <LandingPageLoyaltyBenefitTile
      heading={heading}
      labels={
        <Group direction="horizontal" gap={8} verticalAlign="center">
          <LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>
          <Label kind="primary" variant="highlight">
            {intl.formatMessage({
              id: 'koV0o8bOHuKmhZ9lLlgD',
              defaultMessage: 'New',
              description: 'Promotion label for a newly available loyalty benefit',
            })}
          </Label>
        </Group>
      }
      image={ESIM_IMAGE}
      actions={
        <TextButton kind="secondary" onClick={handleDetailsClick}>
          {intl.formatMessage({
            id: 'g_IssRFQVFwaMlcvmKQU',
            defaultMessage: 'Details',
            description: 'Link button to open the eSIM benefit details modal from tile',
          })}
        </TextButton>
      }
    >
      <BodyText variant="medium">
        {intl.formatMessage({
          id: 'E9Pf6Adfqp88JnUzqvQw',
          defaultMessage: 'Stay connected on every international trip with complimentary mobile data.',
          description: 'Description for eSIM benefit tile on account landing page',
        })}
      </BodyText>
    </LandingPageLoyaltyBenefitTile>
  )
}

export default LandingPageLoyaltyEsimPackage
